import React, { useState, useEffect, useRef } from 'react';
import Icon from '../AppIcon';
import Input from './Input';
import Select from './Select';
import Button from './Button';
import httpHelper, { Method_TYPE } from 'utils/http-helper';
import URL_CONSTANTS from 'constants/url-constants';
import { useNavigate } from 'react-router-dom';
import MessageModal from './MessageModal';
import { isMemberBlocked } from 'utils/member-utils';

const GlobalSearch = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchSaiConnId, setSearchSaiConnId] = useState('');
  const [selectedSamithi, setSelectedSamithi] = useState('');
  const [selectedDistrict, setSelectedDistrict] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [samithis, setSamithis] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [title, setTitle] = useState("Member Enrollment Info");
  const [currentBatch, setCurrentBatch] = useState("");
  const [modelMessage, setModelMessage] = useState("");
  const [showConfirmBtn, setShowConfirmBtn] = useState(false);
  const searchRef = useRef(null);

  const navigate = useNavigate();

  useEffect(() => {
     
    const getSamithiDetails = async () => {

      try {
        const data = await httpHelper(URL_CONSTANTS.GET_SAMITHI_LIST, Method_TYPE.GET); // Replace with actual API endpoint
        setSamithis(data.map(samithi => ({
          value: samithi._id,
          label: samithi.samithiName
        })));
      }
      catch (err) {
        console.error('Error fetching samithi details:', err);
        setSamithis([])
      }
    }

    const getDistrictDetails = async () => {
      try {
        const response = await httpHelper(URL_CONSTANTS.GET_DISTRICT_LIST, Method_TYPE.GET); // Replace with actual API endpoint
        setDistricts(response?.data.map(district => ({
          value: district._id,
          label: district.districtName
        })));
      }
      catch (err) {
        console.error('Error fetching district details:', err);
        setDistricts([])
      }
    }

    getSamithiDetails();
    getDistrictDetails();
    // getCurrentBatch();
     

  },[]);

  // Mock search results
  const mockResults = [
    {
      id: 'M001',
      name: 'Rajesh Kumar',
      samithi: 'Adyar Samithi',
      district: 'Chennai District',
      status: 'allocated',
      seva: 'Kitchen Service'
    },
    {
      id: 'M002',
      name: 'Priya Sharma',
      samithi: 'Mylapore Samithi',
      district: 'Chennai District',
      status: 'unallocated',
      seva: null
    },
    {
      id: 'M003',
      name: 'Suresh Babu',
      samithi: 'Velachery Samithi',
      district: 'Chennai District',
      status: 'allocated',
      seva: 'Registration Desk'
    }
  ];

  const onMemberEditClick =async  (member) => {

      navigate('/add-edit-member', {
        state: {
          isEditing: true,
          memberData: member,
        },
      });
      // Navigate to member edit page or open modal
  }

  const onViewAllotmentClick  = async (member) => {

    try {

      const data = await httpHelper(URL_CONSTANTS.CURRENT_BATCH, Method_TYPE.GET);

      const batchId = data?._id;

      const response =  await httpHelper(`${URL_CONSTANTS.SERVICE}memberServiceInfo/member/${member._id}/batch/${batchId}`,Method_TYPE.GET);

      if(response && response.data.length > 0) {

          const serviceInfo = response.data[0];

          var isAllocated = false;

          let allotmentDetails = "";

          if(serviceInfo && serviceInfo.sector) {
              isAllocated = true;
              allotmentDetails += `Sector : ${serviceInfo.sector.name} \n`;
            
          }

          if(serviceInfo && serviceInfo.deploymentpoint) {
            isAllocated = true;
            allotmentDetails += `Deployment Point : ${serviceInfo.deploymentpoint.name} \n`;

          }
          setTitle("Member Allocation Info");
          if(!isAllocated) {
            allotmentDetails = "Member is in un-allocated bucket. Kindly assign a service.";  
          }
          setModelMessage(allotmentDetails);
          setShowConfirmBtn(false); 
          setShowModal(true);
      }
      else {
        setTitle("Member Allocation Info");
        setModelMessage("Member is not allocated to any service in the current batch.");
        setShowConfirmBtn(false); 
        setShowModal(true);
      }

    }
    catch(err) {
      console.log(err);
      alert("Error fetching member allotment details.")
    }
  }


  const onEnrollClick = async (member) => { 

        if (isMemberBlocked(member)) {
          setTitle("Enrollment Blocked");
          setModelMessage("Member is blocked and cannot be enrolled for service.");
          setShowConfirmBtn(false);
          setShowModal(true);
          return;
        }

        try {

             const data = await httpHelper(URL_CONSTANTS.CURRENT_BATCH, Method_TYPE.GET);

             const batchId = data?._id;
             
             const response =  await httpHelper(`${URL_CONSTANTS.SERVICE}memberallocatedcount/batch/${batchId}/member/${member._id}`,Method_TYPE.GET);

             if(response > 0) {

                 setShowModal(true)

                 setModelMessage("Member already enrolled for this batch.");

                 return;
             }

             const body = {
                batch: batchId,
                member: member._id,
                samithi: member.samithi?._id || "",
                district: member.samithi?.district?._id || "",
             }

              const enrollResponse = await httpHelper(URL_CONSTANTS.SERVICE , Method_TYPE.POST, body);
              setTitle("Member Enrollment Info");
              setShowModal(true)

              setModelMessage("Member Enrolled Successfully.");

              return;

        }
        catch(err) {
          console.error('Error enrolling member:', err);
        }
  }

  const handleSearch = async () => {
    if (!searchQuery.trim() && !searchSaiConnId.trim() && !selectedDistrict && !selectedSamithi) return;
    setIsSearching(true);
    setShowResults(true);

    let searchTerm = ""
    
    if(searchSaiConnId?.trim())
       searchTerm += searchTerm === "" ? "saiOneId="+searchSaiConnId.trim() : "&saiOneId="+searchSaiConnId.trim()
    if(selectedSamithi)
         searchTerm += searchTerm === "" ? "samithi="+selectedSamithi : "&samithi="+selectedSamithi
    if(selectedDistrict)
         searchTerm += searchTerm === "" ? "district="+selectedDistrict : "&district="+selectedDistrict
      if(searchQuery?.trim())
        searchTerm += searchTerm === "" ? "searchTerm="+searchQuery.trim() : "&searchTerm="+searchQuery.trim()
    // Simulate API call
    try {

       const response = await httpHelper(`${URL_CONSTANTS.GET_MEMBER_INFO}?${searchTerm}`, Method_TYPE.GET);
       setSearchResults(response?.data || []);
       setIsSearching(false);
    }
    catch(err) {
      console.error('Error fetching search results:', err);
      setSearchResults([]);
      setIsSearching(false);

    }

  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const clearSearch = () => {
    setSearchQuery('');
    setSelectedDistrict('');
    setSelectedSamithi('');
    setSearchSaiConnId('');
    setSearchResults([]);
    setShowResults(false);
  };

  const getStatusBadge = (status) => {
    const styles = {
      allocated: 'bg-success/10 text-success border-success/20',
      unallocated: 'bg-error/10 text-error border-error/20'
    };

    return (
      <span className={`
        px-2 py-1 text-xs font-caption rounded-full border
        ${styles[status] || styles.unallocated}
      `}>
        {status === 'allocated' ? 'Allocated' : 'Unallocated'}
      </span>
    );
  };

  // Close results when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowResults(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="bg-card rounded-lg border border-border p-6 mb-8 shadow-spiritual-sm" ref={searchRef}>
      <div className="mb-4">
        <h2 className="font-heading font-semibold text-lg text-foreground mb-2">
          Member Search
        </h2>
        <p className="text-sm text-muted-foreground">
          Search for members by name or ID across all samithis
        </p>
      </div>

      {/* Search Filters */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
        <div className="md:col-span-1">
          <Input
            type="search"
            placeholder="Search by name , Email or mobile number"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyPress={handleKeyPress}
            className="w-full bg-gray-100"
          />
        </div>
        <div className="md:col-span-1">
          <Input
            type="search"
            placeholder="Search by Sai Connect ID"
            value={searchSaiConnId}
            onChange={(e) => setSearchSaiConnId(e.target.value)}
            onKeyPress={handleKeyPress}
            className="w-full bg-gray-100"
          />
        </div>
        <Select
          placeholder="Select District"
          options={districts}
          value={selectedDistrict}
          onChange={setSelectedDistrict}
          className="bg-gray-100"
          clearable
          searchable={true}
        />
        
          <div className="md:col-span-1">
            <Select
              placeholder="Select Samithi"
              options={samithis}
              value={selectedSamithi}
              onChange={setSelectedSamithi}
              className="bg-gray-100"
              clearable
              searchable={true}
            />
        </div>
         <div className="flex items-center space-x-3">
          <Button
              variant="default"
              onClick={handleSearch}
              loading={isSearching}
              iconName="Search"
              iconPosition="left"
              disabled={!searchQuery.trim() && ! searchSaiConnId.trim() && !selectedDistrict && !selectedSamithi}
              
            >
              Search Members
            </Button>
            
            {(searchQuery || searchSaiConnId || selectedDistrict || selectedSamithi) && (
              <Button
                variant="outline"
                onClick={clearSearch}
                iconName="X"
                iconPosition="left"
                className="rounded"
              >
                Clear
              </Button>
            )}
      </div>
      </div>

      {/* Search Actions */}
     

      {/* Search Results */}
      {showResults && (
        <div className="mt-6 border-t border-border pt-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-heading font-medium text-foreground">
              Search Results
            </h3>
            <span className="text-sm text-muted-foreground">
              {searchResults.length} member{searchResults.length !== 1 ? 's' : ''} found
            </span>
          </div>

          {isSearching ? (
            <div className="space-y-3">
              {[1, 2, 3].map((i) => (
                <div key={i} className="animate-spiritual-pulse">
                  <div className="bg-muted rounded-lg p-4">
                    <div className="h-4 bg-muted-foreground/20 rounded w-1/3 mb-2"></div>
                    <div className="h-3 bg-muted-foreground/20 rounded w-1/2"></div>
                  </div>
                </div>
              ))}
            </div>
          ) : searchResults.length > 0 ? (
            <div className="space-y-3">
              {searchResults.map((member) => {
                const blocked = isMemberBlocked(member);
                return (
                <div
                  key={member._id}
                  className={`rounded-lg p-4 transition-colors border ${
                    blocked
                      ? 'bg-red-50/80 dark:bg-red-950/20 border-red-300 dark:border-red-800 shadow-sm'
                      : 'bg-muted/50 hover:bg-muted border-border/50'
                  }`}
                >
                  <div className="flex items-start justify-between flex-col gap-3 sm:flex-row w-full">
                    <div className="flex-1 w-full">
                      <div className="flex items-start justify-between space-x-3 mb-2 w-full">
                        <div className="inline-flex flex-wrap items-center gap-2">
                        <h4 className={`font-heading font-medium ${blocked ? 'text-red-900 dark:text-red-300 font-semibold' : 'text-foreground'}`}>
                          {member.name}
                        </h4>
                        {blocked && (
                          <span className="inline-flex items-center gap-1 px-2.5 py-0.5 text-xs font-semibold rounded-full bg-red-100 text-red-700 border border-red-300 dark:bg-red-900/50 dark:text-red-300 dark:border-red-700">
                            <Icon name="AlertCircle" size={12} />
                            Blocked
                          </span>
                        )}
                        <span className="font-mono text-xs text-muted-foreground bg-background px-2 py-1 rounded">
                          {member.saiOneId || ""} | {member.mobNoPrimary || ""}
                        </span>
                        </div>
                        {/* {getStatusBadge("unallocated")} Replace with actual status */}
                      </div>
                      <div className="text-sm text-muted-foreground space-y-1">
                        <p>
                          <Icon name="MapPin" size={14} className="inline mr-1" />
                          {member.samithi?.district?.districtName} • {member.samithi?.samithiName}
                        </p>
                        {member.seva && (
                          <p>
                            <Icon name="Briefcase" size={14} className="inline mr-1" />
                            Current Seva: {member.seva}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="flex items-center md:space-x-2 md:justify-end w-full sm:w-auto sm:-mt-1.5 flex-wrap justify-center gap-2 md:gap-0">
                        <Button
                          variant="outline"
                          size="sm"
                          className="!border border-[#dfdfdf]"
                          iconName="Eye"
                          iconPosition="left"
                          onClick={(e) => {
                            e.stopPropagation();
                            onViewAllotmentClick(member);
                          }}
                        >
                          View Allotment
                        </Button>
                       <Button
                        variant="ghost"
                        size="sm"
                        className="border"
                        iconName="Edit"
                        iconPosition="left"
                        onClick={(e) => {
                          e.stopPropagation();
                          onMemberEditClick(member);
                        }}
                      >
                        Edit
                      </Button>
                      <Button
                        variant={blocked ? "outline" : "default"}
                        size="sm"
                        iconName={blocked ? "Ban" : "User"}
                        className={blocked ? "opacity-50 cursor-not-allowed text-destructive border-destructive/40 hover:bg-transparent" : ""}
                        iconPosition="left"
                        disabled={blocked}
                        title={blocked ? "Blocked member cannot be enrolled for service" : "Enroll Member"}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (!blocked) {
                            onEnrollClick(member);
                          }
                        }}
                      >
                        Enroll
                      </Button>
                    </div>
                  </div>
                   
                </div>
              );
              })}
            </div>
          ) : (
            <div className="text-center py-8">
              <Icon name="Search" size={48} className="text-muted-foreground mx-auto mb-3" />
              <p className="text-muted-foreground">
                No members found matching your search criteria
              </p>
            </div>
          )}
        </div>
      )}

      <MessageModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        title={title}
        showConfirmBtn = {showConfirmBtn}
        message= {modelMessage}
      />
            
    </div>
  );
};

export default GlobalSearch;